import { connectComparison } from './Comparison/ComparisonConnectors';
import ShingleColor from './ShingleColor';

const ShingleColorsList = ({
  houseView,
  onColorClick,
  selectedColor,
  shingle,
  address,
  isPDP,
  selectedShingles,
  canAddMore,
  addToComparison,
  removeFromComparison,
}) =>
  shingle.shingle_colors.map(color => (
    <ShingleColor
      key={color.uuid}
      shingle={shingle}
      color={color}
      houseView={houseView}
      onClick={onColorClick}
      isSelected={selectedColor && color.uuid === selectedColor.uuid}
      address={address}
      isPDP={isPDP}
      compared={selectedShingles}
      addToCompared={addToComparison}
      removeFromCompared={removeFromComparison}
      canAddMore={canAddMore}
    />
  ));
export default connectComparison(ShingleColorsList);
